import React from 'react';
import PropTypes from 'prop-types';
import { testAttributes } from '../Constants';

import { readingTime } from './ReadingTime.module.scss';

export default function ReadingTime({ minutes = '', testId = testAttributes.GRID_POST_READING_TIME })
{
    return (
        <span className={readingTime} data-testid={testId}>
            {minutes} min read
        </span>
    )
}

ReadingTime.propTypes = {
    minutes: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    testId: PropTypes.string,
};
